const dataPlanExtension = {
  dataPlanExtension: {
    heading: "Extensión de datos de Mobile Connect",
    cellModemIMEI: "Número IMEI del módem móvil",
    siteName: "Nombre del sistema",
    siteAddress: "Dirección del sistema",
    cellPlanEndDate: "Fecha de finalización del plan de módem celular",
    daysToExpiry: "Días para caducar",
    currentPlanStatus: "Estado actual del plan",
    gatewaySNo: "Pasarela S.NO",
    paymentStatus: "Estado de pago",
    lastDateOfPurchase: "última fecha de compra",
    extendDataPlan: "Ampliar plan de datos",
    purchasedBy: "Comprado por",
    purchasedFrom: "Comprado de",
    siteId: "ID del sistema",
    orderNo: "número de orden",
    footer: 'Extensión de datos de Mobile Connect',
    total: 'Total',
    record: 'Registros',
    records: 'Registros',
    show: 'Espectáculo',
    enphase_store: 'Enphase Store',
    orderSummary: 'Resumen del pedido.',
    confirmSelection: 'Por favor, confirme su selección a continuación',
    noOfCellModems: 'Número de módems celulares',
    years: 'Años',
    pricePerSite: 'Precio por sitio',
    cancel:'Cancelar',
    submit:'Entregar',
    back: 'Atrás',
    noTokens: '** No hay módems celulares disponibles **',
    redirectToStoreText: '¡Redireccionando a Enphase store! Espere por favor...!',
    toolTipExtensionInfo: 'Solo los planes de módem celulares con menos de 180 días para el vencimiento son elegibles para la extensión.',
    allCellModems: 'Todos los módems celulares',
    dataplanTitleTooltip: 'This is an extension to Enphase monitoring, software/firmware upgrades, and other remote services offered via your existing AT&T cell modem. This extension will enable you to continue using the same physical hardware, beyond its 5-year term you had originally purchased, by renewing its connectivity instead of having to purchase a new physical device.',
    eligibleCellModems: 'Módems celulares elegibles',
    nonAdminInfo: 'Comuníquese con el administrador para ampliar el plan de datos para un módem celular',
    select: 'Seleccionar',
    typeToSearch: 'Escribe para buscar',
    dataPlanExtensionSuccess: "La extensión de datos de mobile connect es exitosa. Puede que el pago tarde algún tiempo en reflejarse en el panel",
    expired: 'Venció',
    active: 'Activo',
    failed: "Pago fallido",
    pending: "Procesando pago",
    success: "Pago exitoso",
  }
}

export default dataPlanExtension